import { createContext } from "react";
import { UserData } from "@/entities/users/types";
import { AccountData } from "@/entities/accounts/types";

export interface EvaluationContext {
  accountId?: string;
  userId?: string;
  [key: string]: any;
}

export interface FeatureFlagsContextProps {
  // True once identify has finished, successfully or not, or its settle timeout has passed;
  // flags read before then are defaults.
  isSettled: boolean;
  isEnabled: (flagName: string) => Promise<boolean>;
  getStringValue: (flagName: string, defaultValue: string) => Promise<string>;
  getNumberValue: (flagName: string, defaultValue: number) => Promise<number>;
  getBooleanValue: (
    flagName: string,
    defaultValue: boolean
  ) => Promise<boolean>;
  getObjectValue: (flagName: string, defaultValue: any) => Promise<any>;
  setEvaluationContext: (context: EvaluationContext) => Promise<void>;
  identify: (user: UserData, account: AccountData) => void;
}

export const FeatureFlagsContext = createContext<
  FeatureFlagsContextProps | undefined
>(undefined);
